module.exports = new __parcel__URL__("ww-title-promo-packages.0992af0c.jpg").toString();